import useTracksStore from '../../../../shared/store/tracks.store.tsx'
import type { Clip } from '../models/clip.ts'
import { recordChange } from './record-change.ts'
import { selectClip } from '@/features/clips/domain/use-cases/select-clip.ts'

export const deleteClip = (clip: Clip): void => {
  useTracksStore.getState().deleteClip(clip.trackId, clip.id)
  selectClip(undefined)
  recordChange()
}
